import uploadFetch from '@/service/fetch/uploadFetch'
import type { GetUploadCertificate, GetUploadCertificateBatch, UploadFileCallback, QueryUploadResult } from '../types'

// 文件上传访问凭证获取
export const getUploadCertificate: GetUploadCertificate = (data = {}) => {
  return uploadFetch({
    method: 'post',
    url: '/common-upload/get-upload-certificate',
    data: data
  })
}

// 文件上传访问凭证获取(批量)
export const getUploadCertificateBatch: GetUploadCertificateBatch = (data = {}) => {
  return uploadFetch({
    method: 'post',
    url: '/common-upload/get-upload-certificate-batch',
    data: data
  })
}

// 文件上传完成回调
export const uploadFileCallback: UploadFileCallback = (data = {}) => {
  return uploadFetch({
    method: 'post',
    url: '/common-upload/upload-file-callback',
    data: data
  })
}

// 文件上传处理结果查询
export const queryUploadResult: QueryUploadResult = (data = {}) => {
  return uploadFetch({
    method: 'post',
    url: '/common-upload/query-upload-result',
    data: data
  })
}
